import React, { useState, useEffect } from "react";

import { showGrade } from "../../../../../utils/textUtils";

import LevelTab from "./LevelTab";
import GradeTab from "./GradeTab";

const FilteringTab = ({
  levels,
  allStudentList,
  selectedParams,
  setSelectedParams,
}) => {
  const [groupedStudentsByLevel, setGroupedStudentsByLevel] = useState({
    unassigned: { name: "클래스 없음", students: [] },
  });
  const [groupedStudentsByGrade, setGroupedStudentsByGrade] = useState({});
  const [selectedTab, setSelectedTab] = useState("학급");

  const handleClickStudent = (studentId) => {
    if (selectedParams.studentId === studentId) {
      setSelectedParams({ levelId: null, studentId: null, studentGrade: null });
    } else {
      setSelectedParams({
        studentId,
        levelId: null,
        studentGrade: null,
      });
    }
  };

  const handleClickAllStudentsByLevel = (levelId) => {
    if (selectedParams.levelId === levelId) {
      setSelectedParams({ levelId: null, studentId: null, studentGrade: null });
    } else {
      setSelectedParams({ levelId, studentId: null, studentGrade: null });
    }
  };

  const handleClickAllStudentsByGrade = (studentGrade) => {
    if (selectedParams.studentGrade === studentGrade) {
      setSelectedParams({ levelId: null, studentId: null, studentGrade: null });
    } else {
      setSelectedParams({ levelId: null, studentId: null, studentGrade });
    }
  };

  useEffect(() => {
    const updatedGroupedStudentsByLevel = levels.reduce(
      (acc, level) => {
        acc[level.id] = { name: level.name, students: [] };
        return acc;
      },
      { unassigned: { name: "클래스 없음", students: [] } }
    );
    const updateGroupedStudentByGrade = {};
    for (let i = 1; i <= 12; i++) {
      updateGroupedStudentByGrade[i] = { name: showGrade(i), students: [] };
    }

    allStudentList.forEach((student) => {
      if (student.level_list && student.level_list.length > 0) {
        student.level_list.forEach((level) => {
          updatedGroupedStudentsByLevel[level.id]?.students.push(student);
        });
      } else {
        updatedGroupedStudentsByLevel.unassigned.students.push(student);
      }
      updateGroupedStudentByGrade[student.grade].students.push(student);
    });

    setGroupedStudentsByLevel(updatedGroupedStudentsByLevel);
    setGroupedStudentsByGrade(updateGroupedStudentByGrade);
  }, [levels, allStudentList]);

  const styles = {
    classListContainer: {
      width: "250px",
      borderRight: "none",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
      borderRight: "1px solid #EBEBEB",
    },
    classList: {
      listStyle: "none",
      padding: "0px",
      margin: "0px",
      overflow: "auto",
    },
    classHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px",
      border: "none",
      fontSize: "16px",
    },
  };

  return (
    <div style={styles.classListContainer}>
      <ul style={styles.classList}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            borderBottom: "1px solid #EBEBEB",
            fontWeight: "bold",
          }}
        >
          <div
            style={{
              width: "50%",
              textAlign: "center",
              padding: "10px",
              fontSize: "16px",
              borderRight: "1px solid #EBEBEB",
              color: selectedTab === "학급" ? "#000" : "#737373",
            }}
            onClick={(e) => setSelectedTab("학급")}
          >
            {"학급"}
          </div>
          <div
            style={{
              width: "50%",
              textAlign: "center",
              padding: "10px",
              fontSize: "16px",
              color: selectedTab === "학년" ? "#000" : "#737373",
            }}
            onClick={(e) => setSelectedTab("학년")}
          >
            {"학년"}
          </div>
        </div>
        {selectedTab == "학급" && (
          <LevelTab
            groupedStudents={groupedStudentsByLevel}
            handleClickAllStudents={handleClickAllStudentsByLevel}
            handleClickStudent={handleClickStudent}
            selectedParams={selectedParams}
          />
        )}
        {selectedTab == "학년" && (
          <GradeTab
            groupedStudents={groupedStudentsByGrade}
            handleClickAllStudents={handleClickAllStudentsByGrade}
            handleClickStudent={handleClickStudent}
            selectedParams={selectedParams}
          />
        )}
      </ul>
    </div>
  );
};

export default FilteringTab;
